var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('clubs-summary',{attrs:{"id":"summary"}}),_c('clubs-summary2',{attrs:{"id":"summary2"}}),_c('clubs-address')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }